import React from 'react';
import i18n from '../../../../../../utils/ChrI18n';
import { useDispatch } from '../../../../../../chronusStore/helper';
import { eventsListingActions } from '../../../../../../chronusStore/slice/eventsListing';

const ViewToggler = ({ isCalendarView }) => {
  const dispatch = useDispatch();
  const buttonClass = 'btn no-waves noshadow';
  const iconClass = 'fa-regular font-16';

  const updateIsCalendarView = value => {
    dispatch(eventsListingActions.updateIsCalendarView(value));
  };

  return (
    <div className='cui-border-radius-6 inline cui-view-toggler-border'>
      <button
        onClick={ () => updateIsCalendarView(false) }
        title={ i18n.t("feature.events.content.list_view") }
        className={ `cui-border-radius-left-5 ${buttonClass} ${ isCalendarView ? '' : 'btn-primary' }` }
      >
        <i className={ `${iconClass} fa-list` }/>
      </button>

      <button
        onClick={ () => updateIsCalendarView(true) }
        title={ i18n.t("feature.events.content.calendar_view") }
        className={ `cui-border-radius-right-5 ${buttonClass} ${ isCalendarView ? 'btn-primary' : '' }` }
      >
        <i className={ `${iconClass} fa-calendar` }/>
      </button>
    </div>
  )
}

export default ViewToggler;